import { render } from "./add-coupon.vue?vue&type=template&id=27fadb37"
import script from "./add-coupon.vue?vue&type=script&lang=js"
export * from "./add-coupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__